// extracted by mini-css-extract-plugin
module.exports = {"HeroIcon":"HeroIcon__HeroIcon__1l0FH","counter":"HeroIcon__counter__e9zdn","close":"HeroIcon__close__1t7F-"};